module.exports = __webpack_public_path__ + "img/parq delux2.1a009aca.jpg";